import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient } from "aws-amplify/api";
import { submitOnboarding as submitOnboardingMutation } from "@/graphql/mutations";

const client = generateClient();

export const submitOnboardingState = create<State<boolean>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const submitOnboardingIsloading = () =>
  submitOnboardingState.setState(() => ({
    isLoading: true,
    isFetching: false,
    data: null,
    error: null,
  }));
export const submitOnboardingIsError = (error: Error) =>
  submitOnboardingState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
    isFetching: false,
  }));
export const submitOnboardingIsSuccess = (result: boolean) =>
  submitOnboardingState.setState(() => ({
    data: result,
    isLoading: false,
    error: null,
    isFetching: false,
  }));

export const resetSubmitOnboardingState = () =>
  submitOnboardingState.setState(() => submitOnboardingState.getInitialState());

export type SubmitOnboardingParams = {
  job: string;
  numberOfLocations: string;
  businessObjectives: string[];
};

export const submitOnboarding = async (params: SubmitOnboardingParams) => {
  submitOnboardingIsloading();

  try {
    const { data } = await client.graphql({
      query: submitOnboardingMutation,
      variables: params,
    });

    submitOnboardingIsSuccess(data.submitOnboarding);
  } catch (e) {
    const errorMessage =
      e instanceof Error
        ? e.message
        : "failed to mutation submitOnboardingMutation";
    submitOnboardingIsError(Error(errorMessage));
  }
};
